import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/promos-offer/offer')({
  component: RouteComponent,
});

function RouteComponent() {
  return <div>Offer Management</div>;
}
